import {InquiryMultiField, InquiryMultiFieldConfig} from "./inquiry_multi_field";

export const LocationFieldConfig = {
    baseHtmlClass: 'inquiry_field--location',
    selector: '.inquiry_field--location'
}

export class LocationField extends InquiryMultiField {

    static new(inquiryForm) {
        if (!inquiryForm.element) { return null }
        const element = inquiryForm.element.querySelector(LocationFieldConfig.selector);
        if (element) { return new LocationField(element, inquiryForm) }
    }

    constructor(id_or_element, inquiryForm) {
        super(id_or_element, inquiryForm);
        this.atypicalLocationIds = this.getAtypicalLocationIds();
        this.atypicalLocationWarningMessage = this.getAtypicalLocationWarningMessage();
        this.humanValuesLUT = this.getHumanValuesLUT();
        this.render(); // Render again so the human value is rendered.
        this.handleEvent(InquiryMultiFieldConfig.changeEventName, this.autocompleteInputValues.bind(this));
    }

    // Fill in missing location value when appropriate.
    // This is fired when the field changes.
    autocompleteInputValues() {
        const beginningInput = this.getBeginningLocationInput();
        const finishingInput = this.getFinishingLocationInput();
        if (!beginningInput || !finishingInput) { return }

        const beginningValue = this.getBeginningLocationInputValue();
        const finishingValue = this.getFinishingLocationInputValue();
        if (beginningValue && !finishingValue) {
            this.getFinishingLocationInput().value = beginningValue;
            this.handleInputChangeEvent();
        } else if (!beginningValue && finishingValue) {
            this.getBeginningLocationInput().value = finishingValue;
            this.handleInputChangeEvent();
        }
    }

    // Returns the single value (an array of location ids) as calculated by looking at each of the inputs.
    getInputsValue() {
        const values = this.getInputsValues();
        if (values.length < 1) { return null }
        return values;
    }

    // For location field we need to handle the Airportrentals values too (which are strings - not ints).
    // So this method tries to cast to Number but falls back to String.
    typecastValue(value) {
        if (value === '' || value === null) { return null }
        return isNaN(Number(value)) ? String(value) : Number(value);
    }

    hasValue() {
        return this.value !== null && this.value !== 0 && (Array.isArray(this.value) && this.value.length > 0);
    }

    // Look up the human value based on the value code eg. 1 => 'Auckland'
    humanValue() {
        if (!this.value || !this.humanValuesLUT) { return } // This function may be called in the super and therefore the LUT may not be defined yet.
        let humanValues = [];
        this.value.forEach((v)=>{
            humanValues.push(this.humanValuesLUT[v])
        });
        return humanValues.join(' → ');
    }

    getHumanValuesLUT() {
        if (!this.inputElements) { return {} }
        let lut = {};
        this.inputElements.forEach((input) => {
            input.querySelectorAll('option').forEach( (optionElement) => {
                if (optionElement.value) {
                    lut[optionElement.value] = optionElement.innerText;
                }
            });
        });
        return lut;
    }

    appendErrors() {
        if (!this.hasValue()) { this.errors.push(`${ this.label } can not be blank.`) }
    }

    appendWarnings() {
        if ( this.isAtypicalLocationSelected() ) { this.warnings.push(`${ this.atypicalLocationWarningMessage }`) }
    }

    isAtypicalLocationSelected() {
        if (!this.hasValue()) return false;
        if (!this.atypicalLocationIds) return false;
        return this.atypicalLocationIds.some( locationId => this.value.includes(locationId) );
    }

    getBeginningLocationInputValueForPriceCheck() {
        const data = this.getBeginningLocationInput().dataset['price_check_location_code_map'];
        if (!data) { return }
        const map = JSON.parse(data);
        const value = this.getBeginningLocationInputValue();
        if (!map || !value) { return }
        const mapping = map.find( (mapping) => { return mapping['id'] === value });
        if (mapping) { return mapping['code'] }
    }

    getFinishingLocationInputValueForPriceCheck() {
        const data = this.getFinishingLocationInput().dataset['price_check_location_code_map'];
        if (!data) { return }
        const map = JSON.parse(data);
        const value = this.getFinishingLocationInputValue();
        if (!map || !value) { return }
        const mapping = map.find( (mapping) => { return mapping['id'] === value });
        if (mapping) { return mapping['code'] }
    }

    getBeginningLocationInputValue() {
        const input = this.getBeginningLocationInput();
        const value = input ? input.value : null;
        return this.typecastValue(value);
    }

    getFinishingLocationInputValue() {
        const input = this.getFinishingLocationInput();
        const value = input ? input.value : null;
        return this.typecastValue(value);
    }

    getBeginningLocationInput() {
        if (!this.inputElements) { this.setInputElements() }
        return this.inputElements[0];
    }

    getFinishingLocationInput() {
        if (!this.inputElements) { this.setInputElements() }
        return this.inputElements[1];
    }

    getAtypicalLocationIds() {
        const data = this.element.dataset['atypical_booking_type_location_ids'];
        if (typeof data === 'undefined' || data == '') { return [] }
        let ids = JSON.parse(data);
        return (!!ids) ? ids : [];
    }

    getAtypicalLocationWarningMessage() {
        const data = this.element.dataset['atypical_booking_type_location_warning_message'];
        if (typeof data === 'undefined' || data == '') { return '' }
        return data;
    }

}